<template>
  <div class="comp-migration-detail">
    <div class="detail-btn">
      <jw-link @click="toggleVisible">查看详情</jw-link>
    </div>
    <migration-detail-drawer v-if="migrationVisible" :visible="migrationVisible" @close="toggleVisible" v-bind="attrs" />
    <migration-v2-drawer v-if="migrationV2Visible" :visible="migrationV2Visible" @close="toggleVisible" v-bind="attrs" />
  </div>
</template>

<script setup>
// TAG: 迁移工具
import { ref, useAttrs } from 'vue';
import MigrationDetailDrawer from './components/migration-detail-drawer/migration-detail-drawer.vue';
import MigrationV2Drawer from './components/migration-v-2-drawer/migration-v-2-drawer.vue';
import { useEnvConfig } from '@/hooks/env-config';
const migrationVisible = ref(false);
const migrationV2Visible = ref(false);
const attrs = useAttrs();
const { config } = useEnvConfig(attrs?.params?.entity);
const toggleVisible = () => {
  if (attrs.params.entity == config?.migrationToolsEntity) {
    migrationVisible.value = !migrationVisible.value;
  } else if (attrs.params.entity == config?.migrationToolsV2Entity) {
    migrationV2Visible.value = !migrationV2Visible.value;
  }
};
</script>
<style scoped lang="less">
@import './migration-detail.less';
</style>
